import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatIconModule } from '@angular/material/icon'
import { Docente } from 'src/app/programas/models/docente.model'
import { SispgService } from 'src/app/programas/services/sispg.service'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-docente',
  templateUrl: 'docente.component.html',
  styleUrls: ['./docente.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
  ]
})
export class DocenteComponent implements OnInit {

  @Input() idPrograma!: number

  docentes = new MatTableDataSource<Docente>()
  docenteColumns: string[] = ['nome', 'linhas', 'action']
  
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private sispgService: SispgService,
  ) {
  }

  ngOnInit(): void {   
    this.sispgService.docentes(this.idPrograma, this.locale).subscribe(data => {
      this.docentes.data = data
      // Carrega fotos em paralelo (sem travar a tabela)
      this.docentes.data.forEach(docente => {
        this.sispgService.fotoLattes(docente.idPessoaFisica)
          .subscribe({
            next: url => docente.fotoLattesUrl = url,
            error: () => docente.fotoLattesUrl = ''
          })
      })
    })
  }

  portalDocentes(docente: Docente) {
    const destino = `https://unesp.br/portaldocentes/docentes?termoBusca=${docente.nome}`
    window.open(destino)
  }

}